import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pulse-sources" }
const _hoisted_2 = { class: "sources" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.source_view, (data, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "src-logo"
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.$slots.image)
              ? _renderSlot(_ctx.$slots, "image", {
                  key: 0,
                  source: data
                }, undefined, true)
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: data
                }, null, 8 /* PROPS */, _hoisted_4))
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($props.showText)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString($options.text), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}